const initialSearch = {
    searchPermissions: {},
    searchLists: [],
    searchCount: 0,
    searchStatus: [],
    changedSearchStatus: [],
    loadingSearch: false,
    errorsSearch: {}
};

const searchReducer = (search = initialSearch, action) => {
    switch (action.type) {
        case "GET_SEARCHLIST_PENDING":
            return { ...search, loadingSearch: true };
        case "GET_SEARCHLIST_FULFILLED":
            return {
                ...search,
                loadingSearch: false,
                searchLists: action.payload,
                searchPermissions: action.permissions,
                searchCount: action.count ?? (Array.isArray(action.payload) ? action.payload.length : 0)
            };
        case "GET_SEARCHLIST_REJECTED":
            return { ...search, loadingSearch: false, errorsSearch: action.payload };
        default:
            return search;
    }
};

export default searchReducer;
